// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// 引入vuex
import store from "@/store"

import Less from 'Less'

import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);


// 全局注册头部标题
import historyTag from './components/historyTag'
Vue.component("historyTag", historyTag)


import axios from 'axios'
import qs from 'qs'


import VueJsonp from 'vue-jsonp'
Vue.use(VueJsonp)
//节流指令

// 中间通信
const VueEvent = new Vue();
export default VueEvent


axios.defaults.timeout = 30000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.baseURL = '';


// post 用formData格式的时候有用
// axios.interceptors.request.use((config) => {
//   if (config.method === 'post') {
//     config.data = qs.stringify(config.data);
//   }
//   return config;
// }, (error) => {
//   return Promise.reject(error);
// });
Vue.prototype.$axios = axios //全局注册，使用方法为:this.$axios

Vue.config.productionTip = false


//全局配置接口
import $api from './util/requestUrl'
Vue.prototype.$api = $api

//接口
import $https from './util/https'
Vue.prototype.$https = $https.https






// 路由
import {getRoute} from "./router";
let user = sessionStorage.getItem('USER');
let TOKEN = sessionStorage.getItem('TOKEN');
user = user?JSON.parse(user):{token:""};

var routers = getRoute(0);
if (user) {
  routers = getRoute(1);
}else {
  routers = getRoute(0);
}
store.commit("setUser",user);
store.commit("setToken",TOKEN);
router.options.routes = routers;
router.addRoutes(routers);


router.beforeEach((to, from, next) => {
  if (to.path == "/") {
    next({ path: '/Login' })
  } else {
    next()
  }
  
})



import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)
// 配置项
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'static/image/error.jpeg',
  loading: 'static/image/loading.gif',
  attempt: 1
})

Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    const ariaEls = el.querySelectorAll('.el-radio__original')
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden')
    })
  }
})



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js